// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format4 } from '../../constants';

/** Algeria */
const DZ: PhoneNumberData = [213, 'DZ', 9, format4];

export default DZ;
